import type { Games } from '~/types/games'

export const useGames = () => {
  const baseUrl = 'games'

  const { fetchAll } = useApi()

  const getCarousel = async () => {
    try {
      const end = new Date()
      const start = new Date()
      start.setMonth(start.getMonth() - 12)

      const dates = buildDatesRange(start, end)

      return fetchAll<Games>(baseUrl, { page: 1, page_size: 10, ordering: '-added', dates })
    } catch (error) {
      console.log(error)
    }
  }

  const getHighlights = async () => {
    try {
      const end = new Date()
      const start = new Date()
      start.setMonth(start.getMonth() - 48)

      const dates = buildDatesRange(start, end)

      return fetchAll<Games>(baseUrl, { page: 1, page_size: 4, ordering: '-metacritic', dates })
    } catch (error) {
      console.log(error)
    }
  }

  const getGamesForCategory = async (category: number | null) => {
    try {
      const end = new Date()
      const start = new Date()
      start.setMonth(start.getMonth() - 48)

      const dates = buildDatesRange(start, end)

      return fetchAll<Games>(baseUrl, { page: 1, page_size: 15, genres: category || undefined, ordering: '-added', dates })
    } catch (error) {
      console.log(error)
    }
  }

  return {
    getCarousel,
    getHighlights,
    getGamesForCategory
  }
}

const toYMD = (date: Date): string => {
  return date.toISOString().slice(0, 10)
}

const buildDatesRange = (start: Date, end: Date): string => {
  return `${toYMD(start)},${toYMD(end)}`
}
